import { render, staticRenderFns } from "./Bier.vue?vue&type=template&id=24cc37c3&scoped=true"
import script from "./Bier.vue?vue&type=script&lang=js"
export * from "./Bier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc37c3",
  null
  
)

export default component.exports